import React from "react";
import styles from "./page-loader.module.css";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import TextLogo from "../TextLogo/TextLogo";

type PageLoaderProps = {};

const PageLoader = ({}: PageLoaderProps) => {
  return (
    <div className={styles.pageLoaderContainer}>
      <div className={styles.boxemLogoContainer}>
        <TextLogo className={styles.textLogo} />
        <LoadingSpinner size="5rem" className={styles.spinner} />
      </div>
    </div>
  );
};

export default PageLoader;